<template>
  <DefaultLayout :disableFacilitatorTools="true">
    <div ref="topdiv" class="layout-card">
      <div v-if="!notLimitedFacilitator">
        {{ $t("company") }} <strong>{{ $store.state.main.userCompany }}</strong>
      </div>
      <div>
        <LimitedFacilitatorHelp v-if="false" />

        <br />
        <div class="text-center">
          <h4>{{ $t("gamestitle") }}</h4>

          <NotificationsAlertbox />

          <base-button class="myButton" type="primary" style="white-space: normal;margin: 2px" @click="create()"
            v-if="notLimitedFacilitator()">{{$t("create")}}</base-button>
          <base-button class="myButton" type="primary" style="white-space: normal;margin: 2px" @click="createLimitedFacilitatorGame()"
            v-if="!notLimitedFacilitator() && ($store.state.main.limited_facilitator_allowed_create_game_scenario_id !== null || $store.state.main.limited_facilitator_allowed_create_game_rps_scenario_id !== null)">{{$t("create")}}</base-button>
          <base-button class="myButton" type="primary" style="white-space: normal;margin: 2px" @click="practice()"
            v-if="notLimitedFacilitator()">{{
              $t("practice")
            }}</base-button>
          <br v-if="notLimitedFacilitator()" />

          <template
            v-if="notLimitedFacilitator() && ($store.state.main.userViewSimulationBrowser || $store.state.main.userRole === 'superadmin')">
            <base-button type="primary" size="sm" style="white-space: normal;margin: 2px"
              @click="$router.push('/admin/scenariobrowser')">{{ $t("scenario-browser") }}</base-button>
          </template>
          <template v-if="false">
            <template
              v-if="$store.state.main.userEnableCombinationReports || $store.state.main.userRole === 'superadmin'">
              <base-button type="primary" size="sm" style="white-space: normal;margin: 2px"
                @click="$router.push('/admin/combinationreport')">{{ $t("combination-report") }}</base-button>
            </template>
          </template>
          <template v-if="$store.state.main.userEditRPSScenarios || $store.state.main.userRole === 'superadmin'">
            <base-button type="primary" size="sm" style="white-space: normal;margin: 2px"
              @click="$router.push('/admin/editor')">{{ $t("simulation-editor") }}</base-button>
          </template>
        </div>
      </div>
      
      <div class="text-center">
        
        <template v-if="$store.state.main.userRole === 'superadmin' || $store.state.main.userRole === 'company_admin'">
          <base-button type="primary" size="sm" style="white-space: normal;margin: 2px" @click=showFacilitators()>{{
            $t("show-facilitators") }}</base-button>
        </template>
        <LogoutButton />
        <base-button v-if="$store.state.main.userViewGamesHistory" type="primary" size="sm"
          style="white-space: normal;margin: 2px" @click="openGamesHistory()">{{ $t("show_partner_games_history")
          }}</base-button>
          <br/>
        <OpenAdminGuideButton />
      </div>

      <br />

      <div class="text-center" v-if="$store.state.main.userRole === 'superadmin'">
        <small>Show secondary fields
          <input type="checkbox" v-on:change="toggleSuperadminColumns()" v-model="superadminShowAllColumns" />
        </small>
        &nbsp;
        <small>Show only invoiceable
          <input type="checkbox" v-model="superadminToggleInvoiceable" />
        </small>
        &nbsp;
        <br />
        <br />
      </div>

      <div class="text-center">
        <small>{{ $t("copylinkhelp") }}</small>
        <br />
        <br />
      </div>

      <div>
        <vue-good-table mode="remote" :rows="getRows" :columns="columns" :totalRows="totalRecords"
          styleClass="vgt-table striped condensed" :search-options="{
            enabled: false
          }" :sort-options="{
            enabled: false,
          }" :pagination-options="{
            enabled: true,
            mode: 'records',
            perPage: $store.state.main.adminGamesPerPage,
            nextLabel: $t('next'),
            prevLabel: $t('previous'),
            dropdownAllowAll: false,
            perPageDropdown: [100, 500, 1000],
            rowsPerPageLabel: $t('rowsperpage'),
            ofLabel: 'of',
            pageLabel: 'page', // for 'pages' mode
            allLabel: $t('all'),
          }" @on-page-change="onPageChange" @on-per-page-change="onPerPageChange">
          <div slot="emptystate"></div>

          <template slot="table-column" slot-scope="props">
            <span v-if="props.column.label != 'after'">
              {{ $t(props.column.label) }}</span>
          </template>

          <template slot="table-row" slot-scope="props">
            <small>
              <span v-if="props.column.field == 'after'">
                <div v-if="!props.row.reporting_open">
                  <span>
                    <base-button style="margin: 2px" class="myButton" size="sm" type="info"
                      @click="openGameLinksDialog(props.row.game_code)">{{ $t("gamelinksdialog") }}</base-button>
                  </span>
                </div>

                <base-button v-if="$store.state.main.userRole === 'limited_facilitator'" style="margin: 2px"
                  class="myButton" size="sm" type="secondary" @click="practiceLimited(props.row.game_code)">{{
                    $t("practice") }}</base-button>

                <div v-if="notLimitedFacilitator() && !props.row.reporting_open">
                  <base-button style="margin: 2px" class="myButton" size="sm" type="secondary"
                    @click="edit(props.row.id)">{{ $t("edit") }}</base-button>
                </div>
                <div v-if="!props.row.reporting_open">
                  <base-button style="margin: 2px" class="myButton" size="sm" type="secondary"
                    @click="goto(props.row.game_code)">{{ $t("goto") }}</base-button>
                </div>
                <div v-if="props.row.reporting_open">
                  <base-button style="margin: 2px" class="myButton" size="sm" type="secondary"
                    @click="gotoReporting(props.row)">{{ $t("gotoreporting") }}</base-button>
                </div>
                <div v-if="props.row.reporting_open" v-b-tooltip.hover
                  :title="props.row.feedback_received ? '' : $t('nofeedback')">
                  <base-button style="margin: 2px" class="myButton" size="sm" type="secondary"
                    :disabled="!props.row.feedback_received" @click="gotoFeedback(props.row)">{{ $t("gotofeedback")
                    }}</base-button>
                </div>
              </span>
              <span v-else-if="props.column.field == 'opened'">
                {{ getOpenedString(props.row.opened) }}
              </span>
              <span v-else-if="props.column.field == 'name'">
                {{ getSimulationName(props.row) }}
              </span>
              <span v-else-if="props.column.field == 'invoiced'">
                <div v-if="!isDemonstrationGame(props.row) && !isPracticeGame(props.row)">
                  <input type="checkbox" v-on:change="changeInvoiced(props.row)" v-model="props.row.invoiced" />
                </div>
                <div v-else-if="isPracticeGame(props.row)">{{ $t("practicegame") }}</div>
                <div v-else>Demo</div>
              </span>
              <span v-else-if="props.column.field == 'smoothteam_invoiced'">
                <div v-if="!isDemonstrationGame(props.row) && !isPracticeGame(props.row)">
                  <input type="checkbox" v-on:change="changeSmoothTeamInvoiced(props.row)"
                    v-model="props.row.smoothteam_invoiced" :class="getSmoothteamInvoicedClass(props.row)" />
                </div>
                <div v-else-if="isPracticeGame(props.row)">
                  {{ $t("practicegame") }}
                </div>
                <div v-else>Demo
                  <br />
                  {{ props.row.demo_reason }}
                </div>
              </span>
              <span v-else-if="props.column.field == 'enable_billing'">
                <input type="checkbox" disabled="true" v-model="props.row.enable_billing" />
              </span>

              <span v-else>{{ props.row[props.column.field] }}</span>
            </small>
          </template>
        </vue-good-table>
        <br />

        <div class="text-center" v-if="showExcelExport()">
          <base-button class="myButton" type="primary" @click="exportToExcel()">{{ $t("excel") }}</base-button>
        </div>

        <div v-if="modalNews">
          <NewsDialog :news=news />
        </div>
      </div>
      <CheckToken />
    </div>
  </DefaultLayout>
</template>

<script>
import Swal from "sweetalert2";
import { VueGoodTable } from "vue-good-table";
import "vue-good-table/dist/vue-good-table.css";
import {
  getGamesPaged,
  getScenarios,
  updateGameInvoiced,
  updateGameSmoothTeamInvoiced,
  getNews,
  getRPSScenarios,
  getUsersForCompany,
} from "@/services/APIService";
import OpenAdminGuideButton from "@/components/OpenAdminGuideButton.vue";
import LogoutButton from "@/components/LogoutButton.vue";
import DefaultLayout from '@/layouts/DefaultLayout.vue';
import NewsDialog from '@/components/NewsDialog.vue'
import NotificationsAlertbox from '@/components/NotificationsAlertbox.vue'
import CheckToken from '@/components/CheckToken'
import LimitedFacilitatorHelp from '@/components/LimitedFacilitatorHelp'

const ExcelJS = require("exceljs");

export default {
  data() {
    return {
      columns: [
        {
          label: "name",
          field: "name",
        },
        {
          label: "company_name",
          field: "company_name",
          hidden: false,
        },
        {
          label: "additional_information",
          field: "additional_information",
          hidden: false,
          sortable: false,
        },
        {
          label: "username",
          field: "username",
          hidden: false,
        },
        {
          label: "opened",
          field: "opened",
        },
        {
          label: "invoiced",
          field: "invoiced",
        },
        {
          label: "smoothteam_invoiced",
          field: "smoothteam_invoiced",
        },
        {
          label: "enable_billing",
          field: "enable_billing",
          sortable: false,
        },
        {
          label: "practicegame",
          field: "practice",
          filterOptions: {
            enabled: this.$store.state.main.userRole === "superadmin",
            filterDropdownItems: ['true', 'false'],
          }
        },
        {
          label: "",
          field: "after",
          sortable: false,
        },
        {
          label: "currentcase",
          field: "current_case_number_for_players",
          sortable: false,
        },
        {
          label: "players_count",
          field: "players_count",
          sortable: false,
        },
      ],
      rows: [],
      hideUsername: true,
      hideCompanyname: true,
      scenarios: [],
      rpsScenarios: [],
      modalNews: false,
      allNews: [],
      gameLinksGameCode: null,
      superadminShowAllColumns: false,
      page: 1,
      totalRecords: 0,
      superadminToggleInvoiceable: false,
    };
  },
  components: {
    VueGoodTable,
    DefaultLayout,
    OpenAdminGuideButton,
    LogoutButton,
    NewsDialog,
    NotificationsAlertbox,
    CheckToken,
    LimitedFacilitatorHelp,
  },
  beforeDestroy() {
    this.$bus.$off("close-news-dialog");
  },
  mounted() {
    getNews().then((news) => {
      this.allNews = news;
    });

    this.$bus.$on("close-news-dialog", () => {
      this.modalNews = false;
    });

    this.$store.commit("reinitializeStore");

    this.loadItems();

    this.$set(this.columns[8], "hidden", true); // hide always practice field, not used at the moment

    // Only superadmin needs to see all fields
    if (
      this.$store.state.main.userRole === "facilitator" ||
      this.$store.state.main.userRole === "limited_facilitator"
    ) {
      this.$set(this.columns[1], "hidden", true); // company
      this.$set(this.columns[3], "hidden", true); // username
      this.$set(this.columns[5], "hidden", true); // invoiced
      this.$set(this.columns[6], "hidden", true); // smoothteam invoiced
      this.$set(this.columns[10], "hidden", true); // current case
      this.$set(this.columns[11], "hidden", true); // number of players
    }

    if (this.$store.state.main.userRole === "limited_facilitator") {
      this.$set(this.columns[2], "hidden", true); // additional information
    }

    if (this.$store.state.main.userRole === "company_admin") {
      this.$set(this.columns[1], "hidden", true); // company
      this.$set(this.columns[6], "hidden", true); // smoothteam invoiced
      this.$set(this.columns[8], "hidden", true); // practice
      this.$set(this.columns[10], "hidden", true); // current case
      this.$set(this.columns[11], "hidden", true); // number of players
    }

    if (this.$store.state.main.userRole !== "superadmin" && !this.$store.state.main.userEnableBilling) {
      this.$set(this.columns[7], "hidden", true); // billing
    }

    if (this.$store.state.main.userRole === "superadmin") {
      this.toggleSuperadminColumns();
    }
  },
  computed: {
    getRows() {
      if (!this.superadminToggleInvoiceable) {
        return this.rows;
      } else {
        return this.rows.filter((row) => {
          return this.isInvoiceable(row);
        })
      }
    },
    news() {
      return this.allNews.filter((news) => news.locale === this.$i18n.locale);
    },
  },
  methods: {
    async showFacilitators() {
      await getUsersForCompany(this.$route.params.gamecode).then(resp => {
        let facilitators = "";

        resp.forEach(user => {
          facilitators += user.first_name + " " + user.last_name + " (" + user.email + ")<br>";
        })

        Swal.fire({
        html: this.$t("facilitators-info") + "<br><br>" + facilitators,
        showDenyButton: false,
        confirmButtonText: "ok",
        allowOutsideClick: false
      });


      });
    },
    getOpenedString(openedTime) {
      if (!openedTime) {
        return "";
      } else {
        return openedTime.split("T")[0];
      }
    },
    getLocaleScenario(row) {
      // For cloned scenarios, use id of master scenario

      if (row.simulation_type === "classic") {
        let scenarioId = row.scenario;

        if (row.cloned) {
          scenarioId = row.master_scenario;
        }

        let localeScenario = this.scenarios.find(
          (scenario) =>
            scenario.locale === this.$i18n.locale &&
            scenario.scenario_id === scenarioId
        );

        // If not found exact match, let's find the first one having description
        if (!localeScenario) {
          localeScenario = this.scenarios.find(
            (scenario) =>
              scenario.scenario_id === scenarioId && scenario.short_description
          );
        }

        return localeScenario;
      } else {
        // RPS scenario
        const localeRPSScenario = this.rpsScenarios.find(
          (rpsScenario) =>
            rpsScenario.locale === this.$i18n.locale &&
            rpsScenario.rps_scenario_id === row.rps_scenario
        );

        if (localeRPSScenario) {
          return localeRPSScenario;
        } else {
          return "";
        }
      }
    },
    getSimulationName(row) {
      const localeScenario = this.getLocaleScenario(row);
      let cloned = "";
      if (row.cloned) {
        cloned = "*"
      }
      if (localeScenario) {
        return row.name + " (" + localeScenario.short_description + cloned + ")";
      } else {
        return row.name;
      }
    },
    logout() {
      this.$store.dispatch("logout");
      this.$router.push("/");
    },
    edit(id) {
      this.$router.push("/admin/games/edit/" + id);
    },
    goto(game_code) {
      this.$router.push("/gamecode/" + game_code);
    },
    gotoReporting(row) {
      let url = "/reporting/gamecode/" + row.game_code;
      if (row.simulation_type === "rockpaperscissors") {
        url = "/rps" + url;
      }
      this.$router.push(url);
    },
    gotoFeedback(row) {
      const url = "/feedback/gamecode/" + row.game_code;
      this.$router.push(url);
    },
    create() {
      this.$router.push("/admin/games/create");
    },
    createLimitedFacilitatorGame() {
      this.$router.push('/admin/games/limited-facilitator/create');
    },
    practiceLimited(game_code) {
      this.$router.push("/admin/practice/gamecode/" + game_code);
    },
    practice() {
      this.$router.push("/admin/games/practice/");
    },
    async loadItems() {
      await getScenarios().then((scenarios) => {
        this.scenarios = scenarios;
      });

      await getRPSScenarios().then((rpsScenarios) => {
        this.rpsScenarios = rpsScenarios;
      });

      getGamesPaged(this.page, this.$store.state.main.adminGamesPerPage).then((games) => {
        this.rows = games.results;
        this.totalRecords = games.count;

        // Let's check if there is a game without a name created by this user.
        // If so, it has been bought from webshop and
        // we have to forward to a page where facilitator
        // can save the name.
        for (let i = 0; i < this.rows.length; i++) {
          if (
            !this.rows[i].name &&
            this.rows[i].username === this.$store.state.main.username
          ) {
            this.$store.dispatch(
              "log",
              "Found a game with no name. Forwarding."
            );

            // Oops, found a game without name!
            this.$router.push("/admin/askgamename/id/" + this.rows[i].id + "/gamecode/" + this.rows[i].game_code);
            break;
          }
        }
      });
    },
    isDemonstrationGame(row) {
      return row.demo;
    },
    isPracticeGame(row) {
      return row.practice;
    },
    changeInvoiced(row) {
      updateGameInvoiced(row.id, row.game_code, row.invoiced);
    },
    changeSmoothTeamInvoiced(row) {
      updateGameSmoothTeamInvoiced(
        row.id,
        row.game_code,
        row.smoothteam_invoiced
      );
    },
    showExcelExport() {
      return (
        this.$store.state.main.userRole !== "facilitator" &&
        this.$store.state.main.userRole !== "limited_facilitator"
      );
    },
    notLimitedFacilitator() {
      return this.$store.state.main.userRole !== "limited_facilitator";
    },
    getUrl(gameCode) {
      return window.location.origin + "/gamecode/" + gameCode;
    },
    exportToExcel() {
      const workbook = new ExcelJS.Workbook();
      workbook.created = new Date();
      workbook.creator = "SmoothTeam";

      const sheet = workbook.addWorksheet("Games");

      if (this.$store.state.main.userRole === "company_admin") {
        sheet.addRow([
          "Simulation name",
          "Simulation",
          "Additional information",
          "Demo game",
          "Demo reason",
          "Creator",
          "Opening time",
          "Invoiced",
          "Number of players",
          this.$store.state.main.userEnableBilling ? "Enable billing" : ""
        ]);
      } else {
        // Super admin
        sheet.addRow([
          "Simulation name",
          "Simulation",
          "Company",
          "Additional information",
          "Demo game",
          "Demo reason",
          "Creator",
          "Opening time",
          "Invoiced",
          "SmoothTeam invoiced",
          "Number of players",
          "Enable billing"
        ]);
      }

      this.rows.forEach((row) => {
        const localeScenario = this.getLocaleScenario(row);

        let scenarioName = "";
        if (localeScenario != null) {
          scenarioName = localeScenario.short_description;
        }

        if (this.$store.state.main.userRole === "company_admin") {
          sheet.addRow([
            row.name,
            scenarioName,
            row.additional_information,
            row.demo,
            row.demo_reason,
            row.username,
            row.opened ? row.opened.split("T")[0] : "",
            row.demo ? "demo" : row.invoiced,
            row.players_count,
            this.$store.state.main.userEnableBilling ? row.enable_billing : ""
          ]);
        } else {
          // Super admin
          sheet.addRow([
            row.name,
            scenarioName,
            row.company_name,
            row.additional_information,
            row.demo,
            row.demo_reason,
            row.username,
            row.opened ? row.opened.split("T")[0] : "",
            row.demo ? "demo" : row.invoiced,
            row.demo ? "demo" : row.smoothteam_invoiced,
            row.players_count,
            row.enable_billing
          ]);
        }
      });

      workbook.xlsx.writeBuffer().then((data) => {
        const blob = new Blob([data], {
          type:
            "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        });
        saveAs(blob, "SmoothTeam_Simulations.xlsx");
      });
    },
    openGameLinksDialog(gameCode) {
      this.$router.push("/gamelinks/" + gameCode)
    },
    toggleSuperadminColumns() {
      if (this.$store.state.main.userRole === "superadmin") {
        this.$set(this.columns[2], "hidden", !this.superadminShowAllColumns); // additional info
        this.$set(this.columns[4], "hidden", !this.superadminShowAllColumns); // opened
        this.$set(this.columns[5], "hidden", !this.superadminShowAllColumns); // invoiced
        this.$set(this.columns[10], "hidden", !this.superadminShowAllColumns); // current case
        this.$set(this.columns[11], "hidden", !this.superadminShowAllColumns); // number of players
      }
    },
    //REST PAGINATION HANDLERS
    onPageChange(params) {
      this.page = params.currentPage;
      this.loadItems();
    },
    onPerPageChange(params) {
      this.$store.commit("setAdminGamesPerPage", {
        adminGamesPerPage: params.currentPerPage,
      });
      this.loadItems();
    },
    openGamesHistory() {
      this.$router.push("/admin/gameshistory/");
    },
    getSmoothteamInvoicedClass(row) {
      if (this.isInvoiceable(row)) {
        return "highlight";
      } else {
        return "";
      }
    },
    isInvoiceable(row) {
      return !row.smoothteam_invoiced && row.open && !row.demo;
    }
  },
};
</script>

<i18n>
{
  "en": {
    "name": "Name",
    "create": "New Simulation",
    "edit": "Edit",
    "gamestitle": "Simulations",
    "next": "next",
    "previous": "previous",
    "rowsperpage": "rows per page",
    "all": "all",
    "logout": "Logout",
    "company": "Company: ",
    "company_name": "Company",
    "opened": "Opening time",
    "username": "Created by",
    "goto": "Enter",
    "team": "Team",
    "gotoreporting": "Report",
    "additional_information": "Additional information",
    "invoiced": "Invoiced",
    "excel": "Export to Excel",
    "smoothteam_invoiced": "SmoothTeam invoiced",
    "copylink": "Copy link",
    "copylinkhelp": "Copy the players' link to the clipboard and forward it to the players. Ask players to open the link only at the start of the simulation. You can access the simulation yourself by clicking the Enter button.",
    "practice": "Practice",
    "practicegame": "Practice",
    "enable_billing": "Billable",
    "news": "News",
    "updated": "Updated",
    "gamelinksdialog": "Simulation links",
    "linkcopied": "Link copied to clipboard",
    "show_partner_games_history": "Show games created by partners",
    "currentcase": "Current case",
    "players_count": "Number of players",
    "simulation-editor": "Share-type Simulation editor",
    "combination-report": "Combination reports",
    "scenario-browser": "Get to know the simulations",
    "gotofeedback": "Feedbacks",
    "nofeedback": "No feedback",
    "show-facilitators": "Show company facilitators",
    "facilitators-info": "Active facilitator accounts in your organization. If you wish to change facilitators, plase contact SmoothTeam."
  },
  "sv": {
    "name": "Simuleringens namn",
    "create": "Ny simulering",
    "edit": "Redigera",
    "gamestitle": "Simuleringar",
    "next": "nästa",
    "previous": "föregående",
    "rowsperpage": "rader på sidan",
    "all": "alla",
    "logout": "logga ut",
    "company": "Företag: ",
    "company_name": "Företagsnamnet",
    "opened": "Simuleringen öppnad",
    "username": "Skapad av",
    "goto": "Gå till",
    "team": "Grupp",
    "gotoreporting": "Rapporterna",
    "additional_information": "Identifiering",
    "invoiced": "Faktureras",    
    "excel": "Exportera till Excel",
    "smoothteam_invoiced": "Fakturerad till SmoothTeam",
    "copylink": "Kopiera länk",
    "copylinkhelp": "Kopiera spelarnas länk till urklipp och vidarebefordra den till spelarna. Be spelarna att öppna länken endast i början av simuleringen. Du kan komma åt simuleringen själv genom att klicka på Gå till -knappen.",
    "practice": "Öva",
    "practicegame": "Öva",
    "enable_billing": "Går att fakturera",
    "news": "Nyheter",
    "updated": "Uppdaterad",
    "gamelinksdialog": "Länkar till simuleringen",
    "linkcopied": "Länken kopierades till urklipp",
    "show_partner_games_history": "Visa spel skapade av partners",
    "currentcase": "aktuellt fall",
    "players_count": "antal spelare",
    "combination-report": "Kombinerade rapporter",
    "scenario-browser": "Kolla in simuleringarna",
    "gotofeedback": "Äterkopplingar",
    "nofeedback": "Ingen återkoppling"
  },
  "fi": {
    "name": "Simulaation nimi",
    "create": "Uusi simulaatio",
    "edit": "Muokkaa",
    "gamestitle": "Simulaatiot",
    "next": "seuraava",
    "previous": "edellinen",
    "rowsperpage": "rivejä sivulla",
    "all": "kaikki",
    "logout": "Kirjaudu ulos",
    "company": "Yritys: ",
    "company_name": "Yritys",
    "opened": "Simulaatio avattu",
    "username": "Luonut",
    "goto": "Siirry",
    "team": "Tiimi",
    "gotoreporting": "Raportit",
    "additional_information": "Yksilöintitieto",
    "invoiced": "Laskutettu",
    "excel": "Vie Exceliin",
    "smoothteam_invoiced": "SmoothTeam laskuttanut",
    "copylink": "Kopioi pelaajien linkki",
    "copylinkhelp": "Kopioi pelaajien linkki leikepöydälle ja välitä pelaajille. Pyydä pelaajia avaamaan linkki vasta simulaation alkaessa. Siirry-napista voit itse siirtyä simulaatioon.",
    "practice": "Harjoittele",
    "practicegame": "Harjoitus",
    "enable_billing": "Laskutettava",
    "news": "Uutiset",
    "updated": "Päivitetty",
    "gamelinksdialog": "Linkit simulaatioon",
    "linkcopied": "Linkki kopioitu leikepöydälle",
    "show_partner_games_history": "Näytä kumppanien luomat pelit",
    "currentcase": "Tilanne",
    "players_count": "Pelaajien määrä",
    "simulation-editor": "Share-Simulaatioeditori",
    "combination-report": "Yhdistelmäraportit",
    "scenario-browser": "Tutustu simulaatioihin",
    "gotofeedback": "Palautteet",
    "nofeedback": "Ei vielä palautetta",
    "show-facilitators": "Näytä organisaation fasilitoijat",
    "facilitators-info": "Organisaatiosi aktiiviset fasilitoitunnukset. Jos haluat vaihtaa tunnuksia, ota yhteyttä SmoothTeamiin."
  },
  "de": {
    "name": "Name",
    "create": "Neue Simulation",
    "edit": "Bearbeiten",
    "gamestitle": "Simulationen",
    "next": "weiter",
    "previous": "zurück",
    "rowsperpage": "Zeilen pro Seite",
    "all": "alle",
    "logout": "Ausloggen",
    "company": "Unternehmen: ",
    "company_name": "Unternehmen",
    "opened": "Öffnungszeit",
    "username": "Erstellt von",
    "goto": "Eingabe",
    "team": "Team",
    "gotoreporting": "Bericht",
    "additional_information": "Zusätzliche Informationen",
    "invoiced": "Invoiced",    
    "excel": "In Excel exportieren",
    "smoothteam_invoiced": "SmoothTeam invoiced",
    "copylink": "Link kopieren",
    "copylinkhelp": "Kopieren Sie den Link der Spieler in die Zwischenablage und leiten Sie ihn an die Spieler weiter. Bitten Sie die Spieler, den Link erst zu Beginn der Simulation zu öffnen. Sie können selbst auf die Simulation zugreifen, indem Sie auf die Schaltfläche Eingabe klicken.",
    "practice": "Trainieren",
    "practicegame": "Train",
    "enable_billing": "abrechnungsfähig",
    "news": "Nachrichten",
    "updated": "Aktualisiert",
    "gamelinksdialog": "Simulationslink",
    "linkcopied": "Link in die Zwischenablage kopiert",
    "show_partner_games_history": "Von Partnern erstellte Spiele anzeigen",
    "currentcase": "aktueller Fall",
    "players_count": "Anzahl der Spieler",
    "combination-report": "Kombinierte Berichte",
    "scenario-browser": "Prüfen Sie die Simulationen",
    "gotofeedback": "Rückmeldungen",
    "nofeedback": "Keine Rückmeldung"
  },
  "ko": {
    "name": "이름",
    "create": "신규 시뮬레이션 개설",
    "edit": "수정하기",
    "gamestitle": "시뮬레이션",
    "next": "다음",
    "previous": "이전",
    "rowsperpage": "한 페이지당 표시 개수",
    "all": "전체",
    "logout": "로그아웃",
    "company": "회사: ",
    "company_name": "회사명",
    "opened": "개설 날짜",
    "username": "개설자",
    "goto": "입장하기",
    "team": "그룹/팀",
    "gotoreporting": "결과보고서",
    "additional_information": "추가 정보",
    "invoiced": "인보이스 발행",
    "excel": "엑셀파일로 다운받기",
    "smoothteam_invoiced": "SmoothTeam invoiced",
    "copylink": "링크 복사하기",
    "copylinkhelp": "링크를 복사하여 참여자에게 전달하세요. 시뮬레이션 시작 시 링크를 클릭할 수 있도록 안내하십시오. 퍼실리테이터는 바로 접속할 수 있습니다.  ",
    "practice": "모의시뮬레이션",
    "practicegame": "모의시뮬레이션",
    "enable_billing": "Billable",
    "news": "뉴스",
    "updated": "업데이트 날짜: ",
    "gamelinksdialog": "시뮬레이션 접속 링크",
    "linkcopied": "클립보드에 복사되었습니다",
    "show_partner_games_history": "외부강사 게임개설이력",
    "currentcase": "현재 케이스",
    "players_count": "플레이어 수",
    "combination-report": "통합 결과보고서",
    "scenario-browser": "시뮬레이션 알아보기",
    "gotofeedback": "피드백",
    "nofeedback": "피드백 없음"
  }
}
</i18n>

<style scoped>
.highlight {
  appearance: none;
  -webkit-appearance: none;
  background-color: red;
  font: inherit;
  color: currentColor;
  width: 1.15em;
  height: 1.15em;
  border: 0.15em solid currentColor;
  border-radius: 0.15em;
  transform: translateY(-0.075em);
}
</style>
